import { useMutation, useQueryClient } from '@tanstack/react-query';

import { QueryKeys } from '../keys';
import { request } from '../request';

export const useDeleteCustomCondition = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => {
      return request(`/custom-conditions/${id}`, { method: 'DELETE' });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QueryKeys.quotations.root });
      queryClient.invalidateQueries({ queryKey: QueryKeys.invoices.root });
      queryClient.invalidateQueries({ queryKey: QueryKeys.invoiceTemplates.root });

      return queryClient.invalidateQueries({ queryKey: QueryKeys.customConditions.index });
    },
  });
};
